module.exports = __webpack_public_path__ + "img/flag_yes.e47f35fc.svg";